const scrollToElement = ({ e, ref }) => {
  e.preventDefault();

  if (!!ref.id) window.location.hash = ref.id;

  window.scrollTo({ left: 0, top: ref.offsetTop - 100, behavior: "smooth" });
};

export default scrollToElement;
